import React, { FC, memo } from 'react';
import {
  makeStyles,
  mergeClasses,
  Spinner,
  tokens,
} from '@fluentui/react-components';

const useLoadingStyles = makeStyles({
  adsCopilotLoading: {
    marginTop: tokens.spacingVerticalM,
    '& svg .fui-Spinner__Tail': {
      animationDuration: '2s !important',
      animationIterationCount: 'infinite !important',
    },
  },
});

export interface ILoadingProps {
  loadingText?: string;
}

export const Loading: FC<ILoadingProps> = memo(({
  loadingText,
}) => {
  const styles = useLoadingStyles();

  return (
    <div className={mergeClasses('ads-copilot-loading', styles.adsCopilotLoading)}>
      <Spinner label={loadingText} size="tiny" />
    </div>
  );
});

Loading.defaultProps = {
  loadingText: 'Generating answers...',
};
